<template>
  <SplitViewTemplate 
    :screenConfig="data" 
    :backButtonRoute="'/settings/production'" 
    :dataModel="formModel"
    :formConfig="setFormConfig" 
    :setLoading="setLoading" 
    :validationSummary="validationSummary" 
    :ref="'bill-type'"
    :defaultUserSettings="false" />
</template>
<script>
import { FeatureStorage } from "@/_services/storage";
import SplitViewTemplate from "../../../templates/split-view";
import RouteMixin from "@/_mixins/route.mixin";
export default {
  mixins: [RouteMixin],
  components: {
    SplitViewTemplate,
  },
  data() {
    return {
      setLoading: false,
      validationSummary: [],
      formModel: {
        Code: null,
        Description: null,
        IsSystemType: true,
        Inactive: false,
        Status: "A",
        ChangedBy: "",
        CreatedBy: "",
        DateChanged: "",
        DateCreated: "",
      },
      data: {
        title: "Bill Type",
        pageRoute: "/bill-type",
        saveEndPoint: "BillType",
        updateEndPoint: "BillType",
        recordEndPoint: "BillType",
        exportFileName: "Bill Types List",
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "BillType",
              filter: "",
              //   select: [
              //     "Code",
              //     "Description",
              //     "Inactive",
              //     "IsDefault",
              //     "RecordId",
              //   ],
              serverPaging: true,
              allowGrouping: false,
              sort: [{ selector: "Description", desc: false }],
            },
            rowSelect: {
              view: this,
              page: "bill-type",
              mode: "review",
              idProperty: "RecordId",
              idMode: "Guid",
              rowSelectCallBack: () => {
                this.beforeInit();
              },
            },
          },

          toolbar: {
            search: true,
            columnChooser: true,
            export: false,
            openFilter: true,
            expand: false,
            customButtons: [
              {
                icon: "plus",
                label: "Add New",
                route: "/bill-type/create",
                clickAction: () => {
                  this.goToCreateBillType();
                },
                buttonLocation: "left",
                // disabled: false,
                visible: FeatureStorage.checkPermission(
                   "ProductionSettings",
                   "create"
                ),
              },
            ],
          },
          columns: [
            {
              screenField: "BillType",
              allowHiding: false,
              sortIndex: 0,
              sortOrder: "asc",
              gridDataField: "Description",
              dataField: "Description",
            },
            {
              label: "System Type",
              dataField: "IsSystemType",
              editorType: "dxCheckBox",
              width: 100,
              dataType: "boolean",
              calculateCellValue: (data) => {
                return data.IsSystemType === "Y" ? true : false;
              },
            },
            {
              screenField: "Status",
              width: "auto",
              filterIndex: 0,
            },
          ],
          valueChangedEventListners: [],
        },
        recordPostProcess: this.recordPostProcess,
      },
      updatedDefaultRecordId: undefined,
      recordEditable: true,
    };
  },
  computed: {
    setFormConfig() {
      const form = {
        headerToolbar: {
          closeSplit: true,
          save: this.setSaveOption,
          audit: true,
          auditItems: [
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  dataField: "FormattedDateCreated",
                  label: { text: "Created By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    disabled: true,
                  },
                },
                {
                  dataField: "FormattedDateChanged",
                  label: { text: "Changed By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    disabled: true,
                  },
                },
              ],
            },
          ],
          toolbarFormItems: [
            {
              screenField: "Inactive",
              editorType: "dxSwitch",
              editorOptions: {
                readOnly: false,
              },
              cssClass: "toolbar-customer-label",
            },
          ],
          toolbarFormLocation: "after",
          editCallBack: () => {
            this.beforeInit();
          },
        },
        formItems: [
          {
            itemType: "group",
            caption: "",
            colCount: 1,
            items: [
              {
                dataField: "Code",
                editorType: "dxTextBox",
                editorOptions: {
                  min: 0,
                  tabIndex: 1,
                  maxLength: 20,
                },
                required: true,
                isPrimaryKeyField: true,
                label: { text: "Code" },
                visible: true,
                allowUpdate: this.baseView.mode == "create" ? true : false,
              },
              {
                dataField: "Description",
                editorType: "dxTextBox",
                editorOptions: {
                  min: 0,
                  tabIndex: 2,
                  maxLength: 30,
                },
                required: true,
                label: { text: "Description" },
                visible: true,
                allowUpdate: this.recordEditable,
              },
              {
                dataField: "IsSystemType",
                label: {
                  text: "System Type",
                },
                editorType: "dxSwitch",
                editorOptions: {
                  allowUpdate: false,
                },
              },
            ],
          },
        ],
        overWritePayload: this.overWritePayload,
      };

      return form;
    },
    setSaveOption() {
      return FeatureStorage.checkPermission(
        this.$route.meta.applicationFeatureCode,
        "create"
      ) && !this.formModel["IsSystemType"];
    },
  },
  methods: {
    goToCreateBillType() {
      this.$router
        .push({
          path: `/bill-type/create`,
        })
        .then(() => {
          this.recordEditable = true;
        });
    },
    beforeInit() {
      this.recordEditable = true;
    },
    overWritePayload(payload) {
      payload.Status = "A";
      //
      if (this.baseView.mode == "create") {
        payload.IsSystemType = "N";
      }
      else {
        payload.IsSystemType = payload.IsSystemType ? "Y" : "N";
      }
      return payload;
    },
    recordPostProcess(data) {
      data["IsSystemType"] = data["IsSystemType"] == "Y" ? true : false;
      return data;
    },
  },
  created() {
    this.beforeInit();
  },
};
</script>
